module.exports = __webpack_public_path__ + "img/avatar0.524d9a41.png";